import type en from '../en/dashboard'
import type { Translation } from '../types'

/** The dashboard: the overview of all sites */
const dashboard: Translation<typeof en> = {
  "dashboard.greeting.morning": "Goedemorgen, {name}",
  "dashboard.greeting.afternoon": "Goedemiddag, {name}",
  "dashboard.greeting.evening": "Goedenavond, {name}",
  "dashboard.subtitle": "Netwerkoverzicht van al uw locaties",
  "dashboard.totalSites": "Locaties totaal",
  "dashboard.acrossAllSites": "Op alle locaties",
  "dashboard.connectedNow": "Nu verbonden",
  "dashboard.activeAlerts": "Actieve meldingen",
  "dashboard.throughput": "Netwerkdoorvoer",
  "dashboard.averageOver": "gemiddeld over {period}",
  "dashboard.download": "↓ Download",
  "dashboard.upload": "↑ Upload",
  "dashboard.allSitesNote": "Alle locaties samen. De geschiedenis per locatie staat op de pagina van elke locatie.",
  "dashboard.recentAlerts": "Recente meldingen",
  "dashboard.allAlerts": "Alle meldingen",
  "dashboard.noAlerts": "Geen actieve meldingen — alle systemen in orde",
  "dashboard.trafficSummary": "Verkeersoverzicht",
  "dashboard.totalReceived": "Totaal ontvangen",
  "dashboard.totalSent": "Totaal verzonden",
  "dashboard.slowestSite": "TRAAGSTE LOCATIE",
  "dashboard.avg": "gem. {rate}",
}

export default dashboard
